import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import dayjs from 'dayjs'
import { toUpper } from 'lodash'

import { request } from '../../../../../../1stlog-ui/src/utils'
import type { UseQueryOptionsWithOptionalKeyAndFn } from '../../../../../types/utility-types'
import { Holiday } from './types'

export const getHolidays = async (
  props?: UseGetHolidaysProps,
): Promise<Holiday[]> => {
  const { url = '/api/list-holidays' } = props || {}
  try {
    const { data } = await request<Holiday[]>({
      method: 'GET',
      url,
    })
    return data
  } catch (err) {
    return []
  }
}

type UseGetHolidaysProps = {
  url?: string
}

export const useGetHolidays = (
  props?: UseGetHolidaysProps,
  options?: UseQueryOptionsWithOptionalKeyAndFn<
    Holiday[],
    AxiosError,
    Holiday[],
    string[]
  >,
): UseQueryResult<Holiday[], Error> => {
  return useQuery({
    queryKey: ['holidays'],
    queryFn: () => getHolidays(props),
    ...options,
  })
}

type UseNextWorkingDayProps = {
  country: string
  zip: string
}

export const useNextWorkingDay = (
  props?: UseNextWorkingDayProps,
): UseQueryResult<string, Error> => {
  const { country, zip } = props || {}

  const queryFn = async (
    props?: UseNextWorkingDayProps,
  ): Promise<string | null> => {
    if (!props || !props.country || !props.zip) {
      return null
    }
    const { country, zip } = props
    try {
      const { data } = await request<{ nextWorkingday: string }>({
        method: 'GET',
        url: `/api/next-working-day/${toUpper(country)}/${zip}`,
      })
      const nextWorkingDay = data?.nextWorkingday
      if (nextWorkingDay) {
        return dayjs(nextWorkingDay).startOf('day').toISOString()
      }
      return null
    } catch (err) {
      return null
    }
  }
  return useQuery({
    queryKey: ['next-working-day', country, zip],
    queryFn: () => queryFn(props),
  })
}
